import type { IRoute } from '@/shared/models/route.model';
import { lazy } from 'react';
import AdminGuard from '@/admin/guards/AdminGuard';

export const ROUTE_COMPANY_ADMIN_DECLARATIONS = Object.freeze({
  CompanyAdminPage: 'company-admins',
  CompanyAdminEditPage: 'company-admins/edit',
});

export const CompanyAdminRoutes: IRoute[] = [
  {
    path: ROUTE_COMPANY_ADMIN_DECLARATIONS.CompanyAdminPage,
    guard: AdminGuard,
    component: lazy(() => import('@/admin/pages/companyAdmin/CompanyAdminPage')),
  },
];
